// extracted by css-extract-rspack-plugin
export default {"styledListWrapper":"qPO6U0fV8c2qT04G__styledListWrapper___"};